"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultEventOptions = {
  prefix: '',
  options: {},
  staticPayload: {}
};

/**
 * Function which allow us to create analytic service for segment events.
 *
 * @param {object} serviceEventOptions - TrackEvent service customization options.
 * @param {string} [serviceEventOptions.prefix=''] - String prefix for all events.
 * @param {TAnyParams} [serviceEventOptions.options={}] - Additional options for trackEvent handler.
 * @param {TAnyParams} [serviceEventOptions.staticPayload={}] - Additional static payload fields.
 * @returns {{
 * addUserProperties: function(object): void,
 * trackEvent: function(object): void,
 * setIdentity: function(number, object, object): void
 * }}
 * @example
 * const analyticService = TrackEvent.createAnalyticService({
 *   staticPayload: { appName: 'new_recipient' },
 *   prefix: 'Recipient - ',
 *   options: { app: { name: 'new_recipient' } },
 * });
 */
var createAnalyticService = function createAnalyticService() {
  var serviceEventOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultEventOptions;
  var _serviceEventOptions$ = serviceEventOptions.prefix,
      prefix = _serviceEventOptions$ === void 0 ? '' : _serviceEventOptions$,
      _serviceEventOptions$2 = serviceEventOptions.options,
      options = _serviceEventOptions$2 === void 0 ? {} : _serviceEventOptions$2,
      _serviceEventOptions$3 = serviceEventOptions.staticPayload,
      staticPayload = _serviceEventOptions$3 === void 0 ? {} : _serviceEventOptions$3;
  return {
    setIdentity: function setIdentity(id, traits, identityOptions) {
      if (window.analytics) {
        window.analytics.identify(id, traits, identityOptions);
      }
    },
    addUserProperties: function addUserProperties(properties) {
      if (window.analytics) {
        window.analytics.identify(properties);
      }
    },
    trackEvent: function trackEvent(_ref) {
      var name = _ref.name,
          _ref$payload = _ref.payload,
          payload = _ref$payload === void 0 ? {} : _ref$payload,
          _ref$options = _ref.options,
          eventOptions = _ref$options === void 0 ? {} : _ref$options;

      if (window.analytics) {
        window.analytics.track("".concat(prefix).concat(name), _objectSpread(_objectSpread({}, staticPayload), payload), _objectSpread(_objectSpread({}, options), eventOptions));
      }
    }
  };
};

var _default = createAnalyticService;
exports["default"] = _default;